(() => {
if (customElements.get('region-collection-search')) return;
const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
class CollectionSearch extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.root = this.closest('[id^="shopify-section-"]');
  this.input = this.querySelector('input');
  this.status = this.querySelector('[data-search-status]');
  this.clear = this.querySelector('[data-search-clear]');
  this.version = 0;
  this.facets = {};
  this.purchasePanel = this.querySelector('[data-purchase-panel]');
  this.purchaseControls = this.querySelector('[data-purchase-controls]');
  this.purchaseReset = this.querySelector('[data-purchase-reset]');
  const shopFamilies = ['vehicle-lifts','heavy-duty-lifts','mobile-columns','air-compressors','air-lubrication-equipment','shop-support-equipment'];
  const sidebar = this.root?.querySelector('.rc-filters');
  if (sidebar && (shopFamilies.includes(this.dataset.family) || this.root.querySelector('.rc-shop-collection'))) {
   this.purchasePanel.classList.add('region-purchase-sidebar');
   sidebar.insertBefore(this.purchasePanel, sidebar.querySelector('button[type="submit"]'));
   this.purchasePanel.open = true;
  }
  this.purchasePanel.addEventListener('toggle', () => {if (this.purchasePanel.open) this.prepareFacets();});
  this.purchaseControls.addEventListener('change', event => {this.facets[event.target.dataset.facet] = event.target.value; this.search();});
  this.purchaseReset.addEventListener('click', () => {this.facets = {}; this.purchaseControls.querySelectorAll('select').forEach(select => {select.value = '';}); this.search();});
  this.searchNavigation = this.querySelector('[data-search-navigation]');
  this.searchNavigation.querySelector('[data-search-previous]').addEventListener('click', () => {this.resultPage--; this.renderMatches();});
  this.searchNavigation.querySelector('[data-search-next]').addEventListener('click', () => {this.resultPage++; this.renderMatches();});
  this.querySelector('form').addEventListener('submit', event => {event.preventDefault(); this.search();});
  this.clear.addEventListener('click', () => {this.input.value = ''; this.search(); this.input.focus();});
  this.input.addEventListener('input', () => {clearTimeout(this.timer); this.version++; this.root.removeAttribute('aria-busy'); this.status.textContent = ''; if (!this.input.value.trim()) this.search();});
  this.input.addEventListener('search', () => {if (!this.input.value.trim()) this.search();});
  if (this.purchasePanel.open) this.prepareFacets();
 }
 async catalog() {
  if (this.cache) return this.cache;
  this.grid = this.root.querySelector('.rc-grid, ul#product-grid');
  if (!this.grid) return [];
  this.original = this.grid.innerHTML;
  this.grid.after(this.searchNavigation);
  this.navigation = [...this.root.querySelectorAll('[data-collection-search-pagination]')];
  const info = this.root.querySelector('[data-collection-search-pages]');
  const pages = Number(info?.dataset.collectionSearchPages || 1);
  const current = Number(info?.dataset.collectionSearchPage || 1);
  const selector = this.grid.matches('.rc-grid') ? '.rc-grid' : 'ul#product-grid';
  const extract = grid => [...grid.children].filter(card => card.hasAttribute('data-collection-search-text')).map(card => ({key:card.dataset.collectionSearchKey, text:normalize(card.dataset.collectionSearchText), attributes:this.attributes(card), html:card.outerHTML}));
  const results = new Map([[current, extract(this.grid)]]);
  const queue = Array.from({length:pages}, (_, i) => i + 1).filter(page => page !== current);
  const worker = async () => {
   while (queue.length) {
    const page = queue.shift();
    const url = new URL(location.href);
    url.hash = '';
    url.searchParams.set('page', page);
    url.searchParams.set('section_id', this.dataset.sectionId);
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) throw new Error('Collection unavailable');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const grid = document.querySelector(selector);
    if (!grid) throw new Error('Collection results unavailable');
    results.set(page, extract(grid));
   }
  };
  this.cache = Promise.all(Array.from({length:Math.min(4, queue.length)}, worker)).then(() => {
   const cards = [...results.entries()].sort((a,b) => a[0]-b[0]).flatMap(entry => entry[1]);
   return [...new Map(cards.map(card => [card.key || card.html,card])).values()];
  }).catch(error => {this.cache = null; throw error;});
  return this.cache;
 }
 attributes(card) {
  let data = {};
  try {data = JSON.parse(card.dataset.purchaseAttributes || '{}');} catch {}
  const title = data.title || '';
  const source = data.source || title;
  delete data.title; delete data.source;
  const list = value => (Array.isArray(value) ? value : String(value || '').split(/[,;]+/)).map(item => String(item || '').trim()).filter(item => item && !/^(per selected model|confirm|n\/a|tbd|not specified)/i.test(item));
  const result = Object.fromEntries(Object.entries(data).map(([key,value]) => [key, [...new Set(list(value).map(item => {
   if (key === 'type') return ({'Reels':'Hose Reels','Handles & Meters':'Control Handles & Meters','FIC':'Fluid Inventory Control','DEF':'DEF Equipment','Mobile Column Lifts':'Mobile Column Lift'}[item] || item);
   if (key === 'capacity') {
    if (/class|two-column set|[\d,]+\s*[–-]\s*[\d,]+/.test(item)) return item;
    const rating = item.match(/([\d,]+)\s*lbs?\b/i);
    if (rating) return Number(rating[1].replace(/,/g,'')).toLocaleString('en-US') + ' lb' + (/per column|single column/i.test(item) ? ' per column' : '');
   }
   if (key === 'power') {const hp = item.match(/([\d.]+)\s*hp\b/i); if (hp) return hp[1] + ' hp';}
   if (key === 'receiver') {const gallons = item.match(/([\d.]+)\s*gal/i); if (gallons) return gallons[1] + ' gal' + (/vertical/i.test(item) ? ' vertical' : /horizontal/i.test(item) ? ' horizontal' : '');}
   return item;
  }))]]));
  if (!result.capacity?.length) {
   const rating = title.match(/([\d,]+(?:[–-][\d,]+)?)\s*(lb\.?s?\.?|tons?)\b/i);
   if (rating) result.capacity = [rating[1] + (/ton/i.test(rating[2]) ? ' ton' : ' lb') + (/single column|per column/i.test(title) ? ' per column' : '')];
  }
  result.fluid = [];
  for (const [label,pattern] of [['Oil',/\boil\b/i],['Grease',/\bgrease\b/i],['DEF',/\bDEF\b|diesel exhaust fluid/i],['Air / water',/air[ /-]+water/i],['Antifreeze / coolant',/antifreeze|coolant|\bAF\b/i],['Windshield washer',/windshield|\bWW[S]?\b/i],['Diesel fuel',/diesel fuel/i],['Used / waste fluid',/used fluid|waste oil|waste fluid/i]]) if (pattern.test(title)) result.fluid.push(label);
  result.drive = [];
  if (/air[ /-]*hydraulic/i.test(title)) result.drive.push('Air / hydraulic');
  else if (/air[ -]operated|air[ -]powered|pneumatic/i.test(source)) result.drive.push('Air powered');
  else if (/hydraulic/i.test(title)) result.drive.push('Hydraulic');
  if (/battery[ -](powered|operated)|battery power/i.test(source)) result.drive.push('Battery powered');
  else if (/electric/i.test(title)) result.drive.push('Electric');
  if (/hand pump|hand[ -]operated|manual pump|manual drain/i.test(title)) result.drive.push('Manual');
  result.mount = [];
  for (const [label,pattern] of [['Wall mounted',/wall[ -]mount/i],['Mobile / portable',/portable|mobile/i],['Stationary',/stationary/i],['Drum / tank mounted',/drum[ -]mount|tank[ -]mount/i]]) if (pattern.test(title)) result.mount.push(label);
  result.set = [...new Set((result.set || []).map(item => {const columns = item.match(/(\d+)[ -]column/i); return columns ? columns[1] + '-column set' : /pair/i.test(item) ? 'Pair / 2 columns' : '';}).filter(Boolean))];
  return result;
 }
 purchaseLabels() {
  const family = this.dataset.family;
  const common = {type:this.dataset.typeLabel || 'Equipment category'};
  if (family === 'vehicle-lifts') return {...common,capacity:'Lifting capacity',deck:'Deck / service configuration',height:'Minimum ceiling clearance'};
  if (family === 'heavy-duty-lifts') return {...common,capacity:'Lifting capacity',deck:'Deck / service configuration',wheelbase:'Maximum wheelbase'};
  if (family === 'mobile-columns') return {...common,capacity:'Capacity / column class',controls:'Control / operating package',set:'Supplied column set'};
  if (family === 'air-compressors') return {...common,power:'Horsepower',supply:'Voltage / phase',receiver:'Tank size / layout',package:'Compressor package'};
  if (family === 'air-lubrication-equipment') return {...common,fluid:'Listed fluid / application',drive:'Operating method',mount:'Mounting / mobility'};
  if (family === 'shop-support-equipment') return {...common,capacity:'Rated capacity',drive:'Operating method'};
  return {...common,capacity:'Capacity / column class',power:'Horsepower',supply:'Voltage / phase',receiver:'Tank size / layout',fluid:'Listed fluid / application',drive:'Operating method',flow:'Hydraulic flow type',application:'Application'};
 }
 async prepareFacets() {
  if (this.facetsReady || this.facetsLoading) return;
  this.facetsLoading = true;
  this.purchaseControls.textContent = '';
  for (const [key,label] of Object.entries(this.purchaseLabels())) {
   const wrapper = document.createElement('label'); wrapper.textContent = label;
   const select = document.createElement('select'); select.setAttribute('aria-label',label); select.disabled = true;
   select.add(new Option('Loading options…','')); wrapper.append(select); this.purchaseControls.append(wrapper);
  }
  this.purchaseControls.setAttribute('aria-busy','true');
  try {
   const cards = await this.catalog();
   const labels = this.purchaseLabels();
   this.purchaseControls.textContent = '';
   for (const [key,label] of Object.entries(labels)) {
    const values = [...new Set(cards.flatMap(card => card.attributes[key] || []))].sort((a,b) => a.localeCompare(b,undefined,{numeric:true}));
    if (!values.length || (values.length < 2 && key !== 'type')) continue;
    const wrapper = document.createElement('label');
    wrapper.textContent = label;
    const select = document.createElement('select');
    select.dataset.facet = key;
    select.setAttribute('aria-label',label);
    select.add(new Option('All ' + label.toLowerCase(),''));
    values.forEach(value => select.add(new Option(value,value)));
    wrapper.append(select);
    this.purchaseControls.append(wrapper);
   }
   if (!this.purchaseControls.children.length) this.purchaseControls.textContent = 'Use manufacturer and search to narrow this collection.';
   this.facetsReady = true;
  } catch {this.purchaseControls.textContent = this.dataset.error;}
  finally {this.facetsLoading = false; this.purchaseControls.removeAttribute('aria-busy');}
 }
 restore() {
  this.version++;
  if (this.grid && this.original !== undefined) this.grid.innerHTML = this.original;
  this.navigation?.forEach(element => {element.hidden = false;});
  this.status.textContent = '';
  this.searchNavigation.hidden = true;
  this.clear.hidden = true;
  this.root?.removeAttribute('aria-busy');
 }
 renderMatches() {
  const pageSize = 24;
  const pages = Math.ceil(this.matches.length / pageSize);
  if (this.grid) this.grid.innerHTML = this.matches.slice((this.resultPage - 1) * pageSize, this.resultPage * pageSize).map(card => card.html).join('');
  this.navigation?.forEach(element => {element.hidden = true;});
  this.searchNavigation.hidden = pages <= 1;
  this.searchNavigation.querySelector('[data-search-previous]').disabled = this.resultPage <= 1;
  this.searchNavigation.querySelector('[data-search-next]').disabled = this.resultPage >= pages;
  this.searchNavigation.querySelector('[data-search-page]').textContent = this.resultPage + ' / ' + pages;
  this.status.textContent = this.matches.length === 0 ? this.dataset.empty : this.matches.length === 1 ? this.dataset.single : this.dataset.count.replace('{count}',this.matches.length);
 }
 async search() {
  const query = normalize(this.input.value);
  const activeFacets = Object.entries(this.facets).filter(([,value]) => value);
  this.purchaseReset.hidden = activeFacets.length === 0;
  if (!query && !activeFacets.length) {this.restore(); return;}
  const version = ++this.version;
  this.clear.hidden = !query;
  this.status.textContent = this.dataset.loading;
  this.root.setAttribute('aria-busy','true');
  try {
   const cards = await this.catalog();
   if (version !== this.version) return;
   const tokens = query.split(' ').filter(Boolean);
   const compact = query.replace(/ /g,'');
   const matches = cards.filter(card => activeFacets.every(([key,value]) => (card.attributes[key] || []).includes(value)) && (!query || tokens.every(token => card.text.includes(token)) || card.text.replace(/ /g,'').includes(compact)));
   this.matches = matches;
   this.resultPage = 1;
   this.renderMatches();
  } catch {
   if (version === this.version) this.status.textContent = this.dataset.error;
  } finally {
   if (version === this.version) this.root.removeAttribute('aria-busy');
  }
 }
}
customElements.define('region-collection-search', CollectionSearch);
})();

